import React from "react";
import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";
import { Section } from "../../components/Section/Section.js";
import { Footer } from "../../components/Footer/Footer";
import { Hero } from "../../components/Hero/Hero.js";
import { CustomerSection } from "../../components/CustomerSection/CustomerSection";
import { ContentsSection } from "../../components/ContentsSection/ContentsSection";
import { CustomerQuote } from "../../components/CustomerQuote/CustomerQuote";

export function Home() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col">
            <Hero />
            <div className="bg-[#242D29] h-40 w-full"></div>
            <ContentsSection />
            <CustomerSection />
            <Section
                className="bg-pine text-white"
                id="timber-purchases"
            >
                <h2 className="font-bold mt-0">{t("timber-purchases-0")}</h2>
                <p>{t("timber-purchases-text-0")}</p>
                <h3 className="font-bold">{t("timber-purchases-1")}</h3>
                <p>{t("timber-purchases-text-1")}</p>
                <h3 className="font-bold">{t("timber-purchases-2")}</h3>
                <p>{t("timber-purchases-text-2")}</p>
                <h3 className="font-bold">{t("timber-purchases-3")}</h3>
                <p>{t("timber-purchases-text-3")}</p>
                <h3 className="font-bold">{t("timber-purchases-4")}</h3>
                <p>{t("timber-purchases-text-4")}</p>
            </Section>
            <Section
                id="forest-management"
                className="bg-white"
            >
                <h2 className="font-bold mt-0">{t("forest-management-0")}</h2>
                <p>{t("forest-management-text-0")}</p>
                <h3 className="font-bold">{t("forest-management-1")}</h3>
                <p>{t("forest-management-text-1")}</p>
                <h3 className="font-bold">{t("forest-management-2")}</h3>
                <p>{t("forest-management-text-2")}</p>
                <h3 className="font-bold">{t("forest-management-3")}</h3>
                <p>{t("forest-management-text-3")}</p>
                <h3 className="font-bold">{t("forest-management-4")}</h3>
                <p>{t("forest-management-text-4")}</p>
            </Section>
            <Section className="bg-[#FAFAFA]">
                <div className="flex w-full text-sm flex-wrap lg:flex-nowrap">
                    <CustomerQuote
                        img={getImage("mats")}
                        quote={t("forest-management-customer-1")}
                        customer="Mats Warensjö, Skogssällskapet"
                    ></CustomerQuote>
                </div>
            </Section>
            <Section className="bg-white">
                <div className="flex w-full text-sm flex-wrap lg:flex-nowrap">
                    <CustomerQuote
                        img={getImage("elin")}
                        quote={t("forest-management-customer-2")}
                        customer="Elin Andersson, JGA Skog"
                    ></CustomerQuote>
                </div>
            </Section>
            <Section
                className="bg-pine text-white"
                id="damage-inventory"
            >
                <h2 className="font-bold mt-0">{t("damage-inventory-0")}</h2>
                <p>{t("damage-inventory-text-0")}</p>
                <h3 className="font-bold">{t("damage-inventory-1")}</h3>
                <p>{t("damage-inventory-text-1")}</p>
                <h3 className="font-bold">{t("damage-inventory-2")}</h3>
                <p>{t("damage-inventory-text-2")}</p>
                <h3 className="font-bold">{t("damage-inventory-3")}</h3>
                <p>{t("damage-inventory-text-3")}</p>
                <h3 className="font-bold">{t("damage-inventory-4")}</h3>
                <p>{t("damage-inventory-text-4")}</p>
                <h3 className="font-bold">{t("damage-inventory-5")}</h3>
                <p>{t("damage-inventory-text-5")}</p>
            </Section>
            <Section className="bg-[#2D3532] text-white">
                <div className="flex w-full text-sm flex-col">
                    <CustomerQuote
                        img={getImage("sara")}
                        quote={t("damage-inventory-customer-1")}
                        customer="Sara Sundin, Stora Enso Sverige"
                    ></CustomerQuote>
                </div>
            </Section>
            <div className="w-full aspect-video bg-[#2D3532]">
                <iframe
                    width="100%"
                    height="100%"
                    src="https://player.vimeo.com/video/1083456758?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    title="Meet Global Forester"
                ></iframe>
                <script src="https://player.vimeo.com/api/player.js"></script>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
            <Section className="bg-[#2D3532] text-white">
                <div className="flex w-full text-sm flex-col">
                    <CustomerQuote
                        img={getImage("peter")}
                        quote={t("damage-inventory-customer-2")}
                        customer="Peter Semb, Norra Skog"
                    ></CustomerQuote>
                </div>
            </Section>
            <Footer />
        </div>
    );
}
